// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n/* BORDERS */\n\n/* Icons */\n#auth {\n  height: 100vh;\n}\n#auth .logo {\n  max-width: 180px;\n}\n#auth .auth-container {\n  min-width: 90vw;\n}\n@media (min-width: 960px) {\n#auth .auth-container {\n    min-width: 33vw;\n}\n}", ""]);
// Exports
module.exports = exports;
